import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Modal, Export } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { FilterTasksRegistrationAwardLeaders } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Status, ButtonGroup, Button, RowSelectorTd } from 'components/misc'
import {
  AwardLeaderDetailModal,
  AwardLeaderRegistrationEditModal
} from 'components/modals'
import {
    apiTasksRegistrationAwardLeaders,
    apiLeaders, apiConfiguration
} from 'helpers/decorators/api'
import { meta, tableCommon } from 'helpers/decorators'
import { tableHeaders } from 'constants/layout/tasks/tasks-registration-award-leaders'
import MODALS from 'constants/modals'
import { modal } from 'redux/modules/app'
import { BulkChangeAwardLeaders } from 'containers/bulkChange'

const enhance = compose(
  meta({
    title: 'Registration',
    intlKey: 'pageTitle.registrations',
    dynamicProp: 'organizations.detail.name'
  }),
  apiTasksRegistrationAwardLeaders({
    tasks: true
  }),
  apiLeaders({
    updateTasks: true
  }),
  tableCommon(),
  apiConfiguration(),
  connect(({ auth }) => ({
    activeOrganization: auth.organization
}), { modal })
)

class RegistrationsAwardLeaders extends Component {
  static propTypes = {
    onAwardLeaderRegistrationEdit: PropTypes.func,
    tasks: PropTypes.object.isRequired,
    setAwardLeadersParams: PropTypes.func,
    approveAwardLeaderRegistration: PropTypes.func.isRequired,
    exportAwardLeaderRegistrations: PropTypes.func.isRequired,
    sendConfirmationEmail: PropTypes.func.isRequired,
    returnAwardLeaderRegistration: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    disablePersistedFilter: PropTypes.bool,
    selectableAwardLeaderIds: PropTypes.array,
    setAwardLeadersSelectedTo: PropTypes.func.isRequired,
    areAllAwardLeadersSelected: PropTypes.bool,
    bulkSelectAwardLeaders: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired
  }

  state = {
    awardLeaderApproveId: null,
    awardLeaderReturnId: null,
    awardLeaderData: {}
  }

  handleApproveLeaderModal = awardLeaderApproveId =>
    this.setState({ awardLeaderApproveId }, () => {
      this.props.modal('modal-leader-approve')
    })

  handleReturnLeaderModal = awardLeaderReturnId =>
    this.setState({ awardLeaderReturnId }, () => {
      this.props.modal('modal-leader-return')
    })

  handleShowLeaderDetails = awardLeaderData => {
    this.setState(
      {
        awardLeaderData
      },
      () => {
        this.props.modal(MODALS.AWARD_LEADER_DETAIL)
      }
    )
  }

  handleEditModal = awardLeaderData => {
    this.setState({ awardLeaderData }, () =>
      this.props.modal(MODALS.EDIT_LEADER_REGISTRATION)
    )
  }

  render() {
    const {
      tasks: {
        registrationAwardLeaders: { loading, list, offset, limit, pages, sort, selectedIds }
      },
      selectableAwardLeaderIds: selectableIds,
      setAwardLeadersParams,
      approveAwardLeaderRegistration,
      returnAwardLeaderRegistration,
      disablePersistedFilter,
      areAllAwardLeadersSelected,
      bulkSelectAwardLeaders,
      setAwardLeadersSelectedTo,
      setCommonLimit
    } = this.props

    const safeSelectedIds = selectedIds || []

      const ExportComponent = (
      <Export
        exportName="AwardLeaderRegistrations"
        toExport={this.props.exportAwardLeaderRegistrations}
        exportSchemeValue="registrations-award-leader"
        count={this.props.tasks && this.props.tasks.count}
      />
    )

    return (
      <div>
        <FilterTasksRegistrationAwardLeaders
          disablePersistedFilter={disablePersistedFilter}
        />

        <BulkChangeAwardLeaders
          selectedIds={safeSelectedIds}
          registrationList={list}
        />

        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tableHeaders(false)}
          areAllSelected={areAllAwardLeadersSelected ? true : undefined}
          bulkSelect={() => bulkSelectAwardLeaders(safeSelectedIds, selectableIds)}
          setParams={setAwardLeadersParams}
          exportComponent={ExportComponent}
        >
          <Data>
            {list.map(({ id, awardLeaderRegistration }) => (
              <tr key={id}>
                <RowSelectorTd
                  enabled={selectableIds && selectableIds.includes(
                    get(awardLeaderRegistration, 'id')) ? true : undefined}
                  selected={selectedIds && selectedIds.includes(
                    get(awardLeaderRegistration, 'id')) ? true : undefined}
                  setSelected={val => setAwardLeadersSelectedTo(
                    get(awardLeaderRegistration, 'id'), val)}
                />
                <td>
                  <span
                    className="link"
                    onClick={() =>
                      this.handleShowLeaderDetails(awardLeaderRegistration)}
                  >
                    {get(awardLeaderRegistration, 'id')}
                  </span>
                </td>
                <td>{get(awardLeaderRegistration, 'firstName')}</td>
                <td>{get(awardLeaderRegistration, 'lastName')}</td>
                <td>
                  {get(awardLeaderRegistration, 'creationDate') &&
                    <FormattedDate
                      value={awardLeaderRegistration.creationDate}
                    />}
                </td>
                <td>
                  {get(awardLeaderRegistration, 'email')}
                  <Status
                    state={get(awardLeaderRegistration, 'isEmailConfirmed')}
                    check
                    inline
                    toRight
                  />
                </td>
                <td>
                  {get(
                    awardLeaderRegistration,
                    'awardLeader.organization.name'
                  )}
                </td>
                <td>
                  <Status
                    state={get(awardLeaderRegistration, 'isCoordinator')}
                    check
                    noWaiting
                  />
                </td>

                <td>
                  <Button
                    onClick={() =>
                      this.handleEditModal(awardLeaderRegistration)}
                    tiny
                    intlKey="button.edit"
                    secondary
                  >
                    Edit
                  </Button>
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      tiny
                      intlKey="button.approve"
                      onClick={() =>
                        this.handleApproveLeaderModal(
                          get(awardLeaderRegistration, 'id')
                        )}
                      disabled={
                        !get(awardLeaderRegistration, 'isEmailConfirmed')
                      }
                    >
                      Approve
                    </Button>
                    <Button
                      tiny
                      intlKey="button.delete"
                      onClick={() =>
                        this.handleReturnLeaderModal(
                          get(awardLeaderRegistration, 'id')
                        )}
                      secondary
                    >
                      Delete
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-leader-approve" customActions>
          <TaskApprove
            approve={approveAwardLeaderRegistration}
            id={this.state.awardLeaderApproveId}
            modal={this.props.modal}
            title="Approve registration"
            intlKey="tasks.approve_registration"
          />
        </Modal>
        <Modal id="modal-leader-return" customActions>
          <TaskReturn
            returnTask={returnAwardLeaderRegistration}
            id={this.state.awardLeaderReturnId}
            modal={this.props.modal}
            title="Delete registration"
            intlKey="tasks.delete_registration"
            noNote
            ctaIntlKey="button.delete"
          />
        </Modal>
        <AwardLeaderDetailModal
          modalId={MODALS.AWARD_LEADER_DETAIL}
          data={this.state.awardLeaderData}
          modal={this.props.modal}
          sendConfirmationEmail={this.props.sendConfirmationEmail}
        />
        <AwardLeaderRegistrationEditModal
          modalId={MODALS.EDIT_LEADER_REGISTRATION}
          data={this.state.awardLeaderData}
          onAwardLeaderEdit={this.props.onAwardLeaderRegistrationEdit}
        />
      </div>
    )
  }
}

export default enhance(RegistrationsAwardLeaders)
